import { render, staticRenderFns } from "./bedItem.vue?vue&type=template&id=36ab8dea&scoped=true"
import script from "./bedItem.vue?vue&type=script&lang=js"
export * from "./bedItem.vue?vue&type=script&lang=js"
import style0 from "./bedItem.vue?vue&type=style&index=0&id=36ab8dea&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36ab8dea",
  null
  
)

export default component.exports